// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2l5mu","tab":"Tabs_tab__2reet","tabActive":"Tabs_tabActive__fxiKJ"};